import { Routes } from '@angular/router';
import { Credential } from '~app/provisioning/credential/credential';
import { NotFound } from '~app/provisioning/not-found/not-found';

export const routes: Routes = [
  {
    path: ':credentialKey',
    component: Credential,
  },
  {
    path: '**',
    component: NotFound,
  },
];
